<header class="page-header">
  <div class="trail">Réglages › Notifications</div>
  <h1>Notifications</h1>
  <p>
    Qui est prévenu de quoi, pour chaque événement d'un contrat. Chaque utilisateur peut ensuite,
    depuis son profil, se retirer d'un courriel ou s'y ajouter.
  </p>
</header>

<aside class="editors-note" role="note">
  <svg lucideInfo aria-hidden="true"></svg>
  <p>
    Ces réglages se modifient par le directeur général et le directeur RH. Une autre personne peut
    en recevoir le droit par le rôle <code>cdt-process-manager</code>, qui n'habilite qu'à cela.
    Tous les autres utilisateurs les consultent sans pouvoir les modifier.
  </p>
</aside>

<section class="panel" aria-label="Événements notifiables">
  <div class="events-table">
    <div class="event-row head">
      <div>Événement</div>
      <div>Destinataires — ligne générale</div>
      <div>Lignes particulières</div>
      <div></div>
    </div>
    @for (group of groups(); track group.label) {
      <div class="family">{{ group.label }}</div>
      @for (row of group.rows; track row.setting.event) {
        <a class="event-row" [routerLink]="['/reglages/notifications', row.setting.event]">
          <div>
            <div class="event-label">{{ row.label }}</div>
            @if (row.description) {
              <div class="event-description">{{ row.description }}</div>
            }
          </div>
          <div>
            <app-designation-chips
              [designations]="row.generalDesignations"
              [emptyLabel]="row.emptyLabel"
            ></app-designation-chips>
            @if (row.cadence) {
              <div class="cadence">{{ row.cadence }}</div>
            }
          </div>
          <div class="particular-lines">
            @switch (row.particularCount) {
              @case (0) {
                Aucune ligne particulière
              }
              @case (1) {
                1 ligne particulière
              }
              @default {
                {{ row.particularCount }} lignes particulières
              }
            }
          </div>
          <svg lucideChevronRight aria-hidden="true"></svg>
        </a>
      }
    }
  </div>
</section>

<p class="legend">
  Les lignes qui s'appliquent à un contrat cumulent leurs destinataires ; aucune n'en retire.
  L'auteur d'un geste n'en est jamais notifié.
</p>
